import { JoinEfbLandingLogo } from "@/assets/JoinEfbLandingLogo";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TourNavigation } from "./TourNavigation";

export const ToolTipLayout: FC<{
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClose: () => void;
  setRun?: (run: boolean) => void;
  currentStep?: number;
  totalSteps?: number;
  onNext?: () => void;
  onPrevious?: () => void;
  showNavigation?: boolean;
  showPrevious?: boolean;
  showNext?: boolean;
}> = ({
  children,
  className,
  style,
  onClose,
  setRun,
  currentStep = 0,
  totalSteps = 1,
  onNext,
  onPrevious,
  showNavigation = false,
  showPrevious = false,
  showNext = false,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        className={`logo-container absolute -bottom-11 -end-2 flex h-[134px] w-[134px] items-center justify-center ${className}`}
        style={style}
      >
        <JoinEfbLandingLogo />
      </div>
      <div style={{ textAlign: "start", position: "relative" }}>
        {/* Skip button in top right corner */}
        <button
          onClick={() => {
            setRun?.(false);
            onClose();
          }}
          className="end-0"
          style={{
            position: "absolute",
            top: "0",
            background: "transparent",
            border: "none",
            color: "#232329",
            textDecoration: "underline",
            fontSize: "14px",
            fontWeight: "400",
            cursor: "pointer",
            padding: "4px 8px",
          }}
        >
          {t("tour.skip")}
        </button>
        {children}

        {/* Navigation component */}
        {showNavigation && onNext && onPrevious && (
          <TourNavigation
            currentStep={currentStep}
            totalSteps={totalSteps}
            onNext={onNext}
            onPrevious={onPrevious}
            showPrevious={showPrevious}
            showNext={showNext}
          />
        )}
      </div>
    </>
  );
};
